import React from 'react';

import { MenuProduct } from 'features/menu/pages/menu-object-page/menu-product-v2';

// old - not one menu
export const MenuObjectPage = () => {
  return <MenuProduct />;
};
